"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineDisclaimerManagers = exports.defineGfaDisclaimerManager = exports.defineDisclaimerManager = exports.defineDisclaimerManagerFactory = void 0;
const gfa_disclaimer_manager_1 = require("@volkswagen-onehub/gfa-disclaimer-manager");
const disclaimer_manager_legal_proxy_1 = require("./disclaimer-manager-legal-proxy");
const v1_1 = require("./v1");
__exportStar(require("./v1"), exports);
__exportStar(require("./disclaimer-manager-legal-proxy"), exports);
const EMPTY_SCOPED_MANAGER_KEY = '---DEFAULT---';
/**
 * Used to get the certain scope of DisclaimerManager
 * If it doesn't exist, it is created and stored inside managers
 */
function getOrCreateV1Manager(scope, managers, options) {
    if (!managers[scope]) {
        managers[scope] = new v1_1.DisclaimerManagerV1Impl(scope, options);
    }
    return managers[scope];
}
const defineDisclaimerManagerFactory = (options) => ({
    id: 'internal:disclaimer-manager-factory',
    create: () => {
        const managers = {};
        const defaultScopesForConsumers = {};
        const defaultLegalForConsumer = {};
        const setDefaultScopeForConsumer = (consumerId, scope) => {
            defaultScopesForConsumers[consumerId] = scope;
        };
        const setDefaultLegalForConsumer = (consumerId, legalEntity) => {
            defaultLegalForConsumer[consumerId] = legalEntity;
        };
        const getV1 = (consumerId) => (scope, legalEntity) => {
            const scopeToGet = scope ||
                defaultScopesForConsumers[consumerId] ||
                EMPTY_SCOPED_MANAGER_KEY;
            // Set as default if this consumer id doesn't have one yet
            if (!defaultScopesForConsumers[consumerId]) {
                defaultScopesForConsumers[consumerId] = scopeToGet;
            }
            // If we have legal entity specified for consumer / FApp
            const legalToGet = legalEntity
                ? legalEntity
                : defaultLegalForConsumer[consumerId];
            return new disclaimer_manager_legal_proxy_1.DisclaimerManagerLegalProxy(getOrCreateV1Manager(scopeToGet, managers, options), legalToGet);
        };
        const factory = (consumerId) => ({
            getScopedDisclaimerManager: getV1(consumerId),
            setDefaultScopeForConsumer,
            setDefaultLegalForConsumer,
        });
        return {
            '1.0.0': () => ({
                featureService: factory,
            }),
        };
    },
});
exports.defineDisclaimerManagerFactory = defineDisclaimerManagerFactory;
const defineDisclaimerManager = () => ({
    id: 'disclaimer-manager',
    dependencies: {
        featureServices: {
            'internal:disclaimer-manager-factory': '^1.0.0',
        },
    },
    create: (env) => {
        const factoryFn = env.featureServices['internal:disclaimer-manager-factory'];
        return {
            '1.4.0': (consumerId) => ({
                featureService: factoryFn(consumerId),
            }),
        };
    },
});
exports.defineDisclaimerManager = defineDisclaimerManager;
const defineGfaDisclaimerManager = () => ({
    id: gfa_disclaimer_manager_1.id,
    dependencies: {
        featureServices: {
            'internal:disclaimer-manager-factory': '^1.0.0',
        },
    },
    create: ({ featureServices }) => {
        const factoryFn = featureServices['internal:disclaimer-manager-factory'];
        return {
            '1.0.0': (consumerId) => ({
                featureService: factoryFn(consumerId),
            }),
        };
    },
});
exports.defineGfaDisclaimerManager = defineGfaDisclaimerManager;
const defineDisclaimerManagers = (options) => [
    (0, exports.defineDisclaimerManagerFactory)(options),
    (0, exports.defineGfaDisclaimerManager)(),
    (0, exports.defineDisclaimerManager)(),
];
exports.defineDisclaimerManagers = defineDisclaimerManagers;
//# sourceMappingURL=index.js.map